/* eslint-disable react/prop-types */
import { motion } from "../../Motion-polyfill";
import React from 'react';
import './style.scss';

const variants_bar = {
  active: {
    width: '100%'
  },
  inactive: {
    width: '0%'
  }
};
const transitions_bar = {
  width: {
    delay: 0,
    duration: 1
  }
};

const variants_text = {
  active: {
    opacity: 1
  },
  inactive: {
    opacity: 0
  }
};
const transitions_text = {
  opacity: {
    delay: 1,
    duration: 0.5
  }
};

function renderBar(animate, className, data) {
  return (
    <div className={className}>
      <div className="metric">
        <div className="bar" style={{ width: `calc(${data.value / data.total} * 100%)` }}>
          <motion.div className="bar-inner" animate={animate} variants={variants_bar} transition={transitions_bar} />
        </div>
        <motion.div className="data" animate={animate} variants={variants_text} transition={transitions_text}>
          {data.valueLabel}
        </motion.div>
      </div>
      <motion.div className="caption" animate={animate} variants={variants_text} transition={transitions_text}>
        {data.title}
      </motion.div>
    </div>
  );
}

export function Chart({ active = false, title, className, prev, next, remark }) {
  const animate = active ? 'active' : 'inactive';
  return (
    <div className={`chart ${className}`}>
      {title && (
        <motion.span className="chart-title" animate={animate} variants={variants_text} transition={transitions_text}>
          {title}
        </motion.span>
      )}
      {renderBar(animate, 'prev', prev)}
      {next && renderBar(animate, 'next', next)}
      {remark && <div className="remark">{remark}</div>}
    </div>
  );
}
